import { render, staticRenderFns } from "./SupportDashboard.vue?vue&type=template&id=74e5fc58&"
import script from "./SupportDashboard.vue?vue&type=script&lang=js&"
export * from "./SupportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports